import React from 'react';
import { formatRupiahFull } from '../data/financialData';

interface APARData {
  payable: {
    accountsPayable: number;
    accruedExpenses: number;
    otherPayable: number;
    total: number;
  };
  receivable: {
    accountsReceivable: number;
    otherReceivableSG: number;
    otherReceivableNseries: number;
    total: number;
  };
}

interface AccountsPayableReceivableProps {
  data: APARData;
  monthLabel: string;
  areaLabel?: string;
}

const badgeStyle: React.CSSProperties = {
  fontSize: '11px', color: '#f59e0b',
  background: 'rgba(245,158,11,0.1)',
  border: '1px solid rgba(245,158,11,0.3)',
  borderRadius: '4px', padding: '1px 6px',
  marginTop: '4px', display: 'inline-block',
};

const AccountsPayableReceivable: React.FC<AccountsPayableReceivableProps> = ({ data, monthLabel, areaLabel }) => {
  return (
    <div className="ap-ar-grid">
      {/* Accounts Payable */}
      <div className="ap-ar-card animate-in">
        <div className="ap-ar-card-header">
          <div className="ap-ar-icon payable">📤</div>
          <div>
            <div className="chart-card-title">Hutang (Accounts Payable)</div>
            <div className="chart-card-subtitle">Tagihan yang harus dibayar - {monthLabel}</div>
            {areaLabel && <span style={badgeStyle}>{areaLabel}</span>}
          </div>
        </div>
        <div className="ap-ar-item">
          <span className="ap-ar-item-label">Accounts Payable</span>
          <span className="ap-ar-item-value">{formatRupiahFull(data.payable.accountsPayable)}</span>
        </div>
        <div className="ap-ar-item">
          <span className="ap-ar-item-label">Accrued Expenses</span>
          <span className="ap-ar-item-value">{formatRupiahFull(data.payable.accruedExpenses)}</span>
        </div>
        <div className="ap-ar-item">
          <span className="ap-ar-item-label">Other Payable</span>
          <span className="ap-ar-item-value">{formatRupiahFull(data.payable.otherPayable)}</span>
        </div>
        <div className="ap-ar-item">
          <span className="ap-ar-item-label" style={{ color: '#f1f5f9' }}>Total Current Liabilities</span>
          <span className="ap-ar-item-value amount-negative">{formatRupiahFull(data.payable.total)}</span>
        </div>
      </div>

      {/* Accounts Receivable */}
      <div className="ap-ar-card animate-in">
        <div className="ap-ar-card-header">
          <div className="ap-ar-icon receivable">📥</div>
          <div>
            <div className="chart-card-title">Piutang (Accounts Receivable)</div>
            <div className="chart-card-subtitle">Faktur menunggu pembayaran - {monthLabel}</div>
            {areaLabel && <span style={badgeStyle}>{areaLabel}</span>}
          </div>
        </div>
        <div className="ap-ar-item">
          <span className="ap-ar-item-label">Accounts Receivable</span>
          <span className="ap-ar-item-value">{formatRupiahFull(data.receivable.accountsReceivable)}</span>
        </div>
        <div className="ap-ar-item">
          <span className="ap-ar-item-label">Other Receivable - SG</span>
          <span className="ap-ar-item-value">{formatRupiahFull(data.receivable.otherReceivableSG)}</span>
        </div>
        <div className="ap-ar-item">
          <span className="ap-ar-item-label">Other Receivable - N-Series</span>
          <span className="ap-ar-item-value">{formatRupiahFull(data.receivable.otherReceivableNseries)}</span>
        </div>
        <div className="ap-ar-item">
          <span className="ap-ar-item-label" style={{ color: '#f1f5f9' }}>Total Receivable</span>
          <span className="ap-ar-item-value amount-positive">{formatRupiahFull(data.receivable.total)}</span>
        </div>
      </div>
    </div>
  );
};

export default AccountsPayableReceivable;
